import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';

import { MenuItem } from 'primeng/api';
import { EoFormPanelConfig } from '../../form/eo-form-panel/eo-form-panel.model';
import {
  EoFormComponent,
  EoFormDisplayMode,
} from '../../form/eo-form/eo-form.component';
import { EoFormTableComponent } from '../eo-form-table/eo-form-table.component';
import { EoFormTableConfig } from '../eo-form-table/model/eo-form-table-config.model';
import { EoFormGroupListConfig } from './model/eo-form-group-list-config.model';

@Component({
  selector: 'eo-form-group-list',
  templateUrl: './eo-form-group-list.component.html',
  styleUrl: './eo-form-group-list.component.scss',
})
export class EoFormGroupListComponent {
  @Input() displayModeChangeVisible = false;

  private _config?: EoFormGroupListConfig;
  @Input() set config(val: EoFormGroupListConfig | undefined) {
    this._config = val;
    this.groupLists = this.getGroupLists(
      (this.config?.formConfig?.config as EoFormPanelConfig[]) ?? []
    );

    this.onGroupItemClick(this.groupLists[0]?.items?.[0], false);

    this.render =
      this.config?.formConfig?.config?.length != 0 ||
      this.config.formTableConfigs?.length != 0;
  }
  get config(): EoFormGroupListConfig | undefined {
    return this._config;
  }

  @Input() staticStepComponents: { [key: string]: TemplateRef<any> | null } =
    {};

  @ViewChild('eoForm', { static: false }) eoForm?: EoFormComponent;

  @ViewChildren('eoFormTable') eoFormTables?: QueryList<EoFormTableComponent>;

  @Input() onDeleteItem = new EventEmitter<any>();
  @Output() menuItemClick = new EventEmitter();

  protected render = false;
  protected modeOptions = [
    {
      value: 'default',
      icon: 'pi pi-th-large',
    },
    {
      value: 'groupLists',
      icon: 'pi pi-list-check',
    },
  ];
  protected _displayMode: EoFormDisplayMode = 'groupLists';
  set displayMode(val: EoFormDisplayMode) {
    this._displayMode = val;
    this.onDisplayModeChange(val);
    this.selectedFormPanel = this.config?.formConfig
      ?.config?.[0] as EoFormPanelConfig;
  }
  get displayMode(): EoFormDisplayMode {
    return this._displayMode;
  }

  protected groupLists: MenuItem[] = [];
  getGroupLists(configs: EoFormPanelConfig[]): MenuItem[] {
    const grouped: { [key: string]: MenuItem } = {};

    configs.forEach((config, i) => {
      const groupName = config.groupName || '';

      if (!grouped[groupName]) {
        grouped[groupName] = {
          label: groupName,
          items: [],
          expanded: true,
        };
      }

      grouped[groupName].items?.push({
        id: config.name,
        label: config.header || config.name,
      });
    });

    return Object.values(grouped);
  }

  selectedFormPanel?: EoFormPanelConfig;
  selectedFormTable?: EoFormTableConfig;

  protected isMobile = false;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 768;
  }

  get valid(): boolean {
    if (this.eoForm != undefined && !this.eoForm.form.valid) return false;

    let formTableValid = true;
    this.eoFormTables?.forEach((table) => {
      if (!table.valid) formTableValid = false;
    });
    if (!formTableValid) return false;

    return true;
  }

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  onDisplayModeChange(displayMode: EoFormDisplayMode): void {
    this.eoForm?.onDisplayModeChange(displayMode);
  }

  onGroupItemClick(item?: MenuItem, emitEvent = true): void {
    if (!item) return;
    this.eoForm?.onGroupItemClick(item);
    this.selectedFormPanel =
      (this.config?.formConfig?.config?.find(
        (panel) => (panel as EoFormPanelConfig).name === item.id
      ) as EoFormPanelConfig) ?? undefined;

    this.selectedFormTable =
      this.config?.formTableConfigs?.find((table) => table.id === item.id) ??
      undefined;

    if (emitEvent) {
      this.menuItemClick.emit({
        menuItem: item,
        selectedFormPanel: this.selectedFormPanel,
        selectedFormTable: this.selectedFormTable,
      });
    }
  }

  public setSelectedMenuItem(item: MenuItem): void {
    this.onGroupItemClick(item, false);
  }

  onDeleteClick($event: any): void {
    this.onDeleteItem.emit($event);
  }

  get stepperVisible(): boolean {
    return this.displayMode === 'groupLists';
  }

  isGroupItemValid(name: string): boolean {
    let tableValid = true;
    this.config?.formTableConfigs?.forEach((table) => {
      if (table.tableData?.length === 0) {
        tableValid = false;
      }
    });

    if (this.eoForm)
      return (
        this.eoForm.formPanelFieldCount(name) > 0 &&
        this.eoForm.isFormPanelValid(name) &&
        this.eoForm.formPanelHasValues(name) &&
        tableValid
      );

    return tableValid;
  }

  isFormTableVisible(config: EoFormTableConfig): boolean {
    if (this.config?.formConfig?.displayMode === 'default') return true;
    return this.selectedFormPanel?.name === `panel_${config.groupId}`;
  }

  isStaticComponent(): boolean {
    return this.config?.isStaticComponent ?? false;
  }
}
